import React from 'react'
import FavoriteItem from './FavoriteItem'
import Divider from '@material-ui/core/Divider'

const FavoriteList = (
  <div>
    {[1, 2, 3, 4].map((item, index) => (
      <React.Fragment key={index}>
        <FavoriteItem />
        {index !== 3 && <Divider />}
      </React.Fragment>
    ))}
  </div>
)

export default FavoriteList
